export * from './crossObjectsController.service';
import { CrossObjectsControllerService } from './crossObjectsController.service';
export * from './displayBookController.service';
import { DisplayBookControllerService } from './displayBookController.service';
export * from './hedgeTradesController.service';
import { HedgeTradesControllerService } from './hedgeTradesController.service';
export * from './managingController.service';
import { ManagingControllerService } from './managingController.service';
export * from './marketMakingPairSettingsController.service';
import { MarketMakingPairSettingsControllerService } from './marketMakingPairSettingsController.service';
export * from './marketMakingPairStatusController.service';
import { MarketMakingPairStatusControllerService } from './marketMakingPairStatusController.service';
export * from './marketMakingRoutesController.service';
import { MarketMakingRoutesControllerService } from './marketMakingRoutesController.service';
export * from './marketMakingSecondLegRoutesController.service';
import { MarketMakingSecondLegRoutesControllerService } from './marketMakingSecondLegRoutesController.service';
export * from './marketMakingSecondLegSettingsController.service';
import { MarketMakingSecondLegSettingsControllerService } from './marketMakingSecondLegSettingsController.service';
export * from './marketMakingSecondLegStatusesController.service';
import { MarketMakingSecondLegStatusesControllerService } from './marketMakingSecondLegStatusesController.service';
export * from './marketMakingTradesController.service';
import { MarketMakingTradesControllerService } from './marketMakingTradesController.service';
export * from './platformBalancesController.service';
import { PlatformBalancesControllerService } from './platformBalancesController.service';
export * from './systemSettingsController.service';
import { SystemSettingsControllerService } from './systemSettingsController.service';
export * from './webSocketMessageTypes.service';
import { WebSocketMessageTypesService } from './webSocketMessageTypes.service';
export const APIS = [
  CrossObjectsControllerService,
  DisplayBookControllerService,
  HedgeTradesControllerService,
  ManagingControllerService,
  MarketMakingPairSettingsControllerService,
  MarketMakingPairStatusControllerService,
  MarketMakingRoutesControllerService,
  MarketMakingSecondLegRoutesControllerService,
  MarketMakingSecondLegSettingsControllerService,
  MarketMakingSecondLegStatusesControllerService,
  MarketMakingTradesControllerService,
  PlatformBalancesControllerService,
  SystemSettingsControllerService,
  WebSocketMessageTypesService,
];
